import request from '@/utils/request';


let server = {
  select: '/security'
};


//  商城大礼包
export function shoppingMall(params) {
	return request({
    	url: server.select,
      method: 'post',
      data: params
  	})
}


// WEBPACK FOOTER //
// ./src/api/security.js